<template>
	<slot />
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { useRouter } from 'vue-router';
import config from "@/config";
import { useGTMStore } from "@/stores/useGTMStore";
import { useNavigationStore } from "@/stores/useNavigationStore";

const router = useRouter();
const gtmStore = useGTMStore();
const navStore = useNavigationStore();
const stepIndex = ref<number>(0);

/**
 * Every event below is sent after a certain step is finished.
 * So we want to check our 'from' route if we came from that specific step to send our event data.
 *
 * Check on the step index whether we should send the event, because we only want to send the event
 * when our index is increasing. Not when returning to previous steps.
 */
router.afterEach((to, from) => {
  const newStepIndex = navStore.currentStepIndex();

  if(newStepIndex > stepIndex.value) {
    if (from.name === 'arrangement_hotel_choices') {
      gtmStore.sendEvent("add_arrangement_hotel_rooms")
    }

    if (from.name === 'arrangement_product_choices') {
      gtmStore.sendEvent("add_arrangement_products")
    }

    if (from.name === 'lunch_and_diner') {
      gtmStore.sendEvent("add_meal_options")
    }

    if (from.name === 'treatments') {
      gtmStore.sendEvent("add_treatments")
    }

    if (from.name === 'rituals') {
      gtmStore.sendEvent("add_rituals")
    }
  }

  stepIndex.value = navStore.currentStepIndex();
});

onMounted(() => {
  gtmStore.$patch({resort: config.theme})

  // Send the first event upon knowing the first checkout status
  gtmStore.sendEvent("begin_reservation")
})
</script>
